import React from 'react';
import {
    hideLeftPaneButton as Strings_hideLeftPaneButton,
    showLeftPaneButton as Strings_showLeftPaneButton,
} from '../strings/toggleLeftPaneButton.locstring.json';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { V8ToggleButton } from './V8ToggleButton';
import { V9ToggleButton } from './V9ToggleButton';

type ExtraTopRibbonControlsBeforeTabsProps = {
    isExpanded: boolean;
    onClick: () => void;
};

export const ExtraTopRibbonControlsBeforeTabs: React.FunctionComponent<ExtraTopRibbonControlsBeforeTabsProps> =
    observer(({ isExpanded, onClick }: ExtraTopRibbonControlsBeforeTabsProps) => {
        const sharedProps = {
            label: loc(isExpanded ? Strings_hideLeftPaneButton : Strings_showLeftPaneButton),
            onClick,
        };

        return isFeatureEnabled('mon-ribbon-fluent-v9-ribbon') ? (
            <V9ToggleButton {...sharedProps} />
        ) : (
            <V8ToggleButton {...sharedProps} />
        );
    }, 'ExtraTopRibbonControlsBeforeTabs');
